import { CommandeAnalyse } from './types';
import { isOffreValide } from './statutOffre';
import { getMontantScoring } from './montants';

// Coeur du calcul d'attribution. Ponderation figee 55% technique / 45% financier
// (decision metier 2026-06-12 : le code vivant appliquait deja 0.55/0.45 ; le commentaire
// legacy "70/30" etait faux). Constantes nommees -> une seule source de verite.
export const WEIGHT_TECHNIQUE = 0.55;
export const WEIGHT_FINANCIERE = 0.45;
export const MAX_NOTE_FINANCIERE = 10;

export const round2 = (n: number): number => Math.round(n * 100) / 100;

// Score total d'une offre = technique pondere + financier pondere.
export const scoreTotal = (techScore: number, finScore: number): number =>
  techScore * WEIGHT_TECHNIQUE + finScore * WEIGHT_FINANCIERE;

export interface FinancialOffer {
  id: number | string;
  montant: number;
}

// Pool de scoring de secours : offres EN LICE (ni refusees ni expirees) ayant un prix_total.
// Corrige le filtre legacy (!== 12 seul) en excluant aussi les refus (6).
export const buildFinancialPool = (commandes: CommandeAnalyse[]): FinancialOffer[] =>
  commandes
    .filter((c) => isOffreValide(c.id_status) && getMontantScoring(c) !== undefined)
    .map((c) => ({ id: c.id ?? '', montant: getMontantScoring(c) as number }));

// Score financier de SECOURS (le moins-disant obtient 10, les autres au prorata lineaire).
// Reproduit verbatim calculateNoteFinanciere du legacy (AnalyseOffreFinanciere l.102-120).
export const calculateFinancialScore = (
  commandeId: number | string | undefined,
  pool: ReadonlyArray<FinancialOffer>,
): number => {
  if (!pool.length) return 0;
  const current = pool.find((m) => String(m.id) === String(commandeId))?.montant;
  if (current === undefined) return 0;
  const montants = pool.map((m) => m.montant);
  const minMontant = Math.min(...montants);
  const maxMontant = Math.max(...montants);
  if (pool.length === 1 || minMontant === maxMontant) return MAX_NOTE_FINANCIERE;
  const note = ((maxMontant - current) / (maxMontant - minMontant)) * MAX_NOTE_FINANCIERE;
  return round2(note);
};

// Note financiere d'une offre : le backend (note_financiere) fait autorite ; le calcul
// local n'est qu'un secours. Reproduit `presta.note_financiere ?? calculateNoteFinanciere`.
export const resolveNoteFinanciere = (
  commande: CommandeAnalyse,
  pool: ReadonlyArray<FinancialOffer>,
): number => {
  if (commande.note_financiere !== null && commande.note_financiere !== undefined) {
    return Number(commande.note_financiere);
  }
  return calculateFinancialScore(commande.id, pool);
};
